// extracted by mini-css-extract-plugin
export default {"menu":"NavbarMenuLinks_menu__qX5sL","menuItem":"NavbarMenuLinks_menuItem__xNmV-"};